export class UnauthenticatedError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = 'UnauthenticatedError';
    }
}
//# sourceMappingURL=unauthenticated_error.js.map